var DualRowPackageWithDifferentPadsData = require('./dualRowPackageWithDifferentPadsData.js');
var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var EllipseData = require('../../../svg/ellipseData.js');
var PathData = require('../../../svg/pathData.js');
var PathObjectData = require('../../../svg/pathObjectData.js');
var PathType = require('../../../svg/pathType.js');
var IPCRules = require('../ipcRules');

var Sot143Data = function(position, angle, init) {
    DualRowPackageWithDifferentPadsData.apply(this, arguments);
};

lib_core.inherit(Sot143Data, DualRowPackageWithDifferentPadsData);
lib_core.JsonParser.registerClass(Sot143Data, "Sot143Data");

module.exports = Sot143Data;

Sot143Data.prototype.getPads = function(absolutePositions) {
    var self = this;
    var pads = [];

    //reset component
    self.component.reset();

    self.updateComponentCalculator(self.horizontalLeadToLeadSpanMin(), self.horizontalLeadToLeadSpanMax());

    var hPitch = self.component.C,
        vPitch = self.verticalPinPitch(),
        motif = self.getMotif(),
        padWidth = motif.getTopCopper().width(),
        padHeight = motif.getTopCopper().height(),
        normalRx = motif.getTopCopper().rx(), //used to restore roundness of normal pad
        normalRy = motif.getTopCopper().ry(),
        leftPadCount = self.component.padsPerSide[0],
        rightPadCount = self.component.padsPerSide[1],
        rowIdx,
        oddPad,
        idx;

    //update first left pad which can have different width than other
    if (self.oddPadHeightMax()) {
        if (self.oddPadHeightMax() !== self.padHeightMax() || self.oddPadHeightMin() !== self.padHeightMin()) {
            self.component.padHeightMax = self.oddPadHeightMax();
            self.component.padHeightMin = self.oddPadHeightMin();

            self.updateComponentCalculator();
            motif = self.getMotif();
        }
    }

    //left first pad
    oddPad = motif.clone();
    //odd pad top edge should be aligned with the same of right first pad
    oddPad.move(new lib_geometry.Coord(-0.5 * hPitch, 0.5 * vPitch - oddPad.getTopCopper().height() / 2 + padHeight / 2));
	pads.push(oddPad);

    //left last pad
    var pad = motif.clone();
    //pad.name(self.nameList.get(1));
    pad.padstack().topCopper().width(padWidth);
    pad.padstack().topCopper().height(padHeight);
    pad.padstack().topCopper().rx(normalRx);
    pad.padstack().topCopper().ry(normalRy);

    pad.move(new lib_geometry.Coord(-0.5 * hPitch, -0.5 * vPitch));

    pads.push(pad);

    //right pads
    for (idx = 0; idx < rightPadCount; idx++) {
        rowIdx = rightPadCount - 1 - idx % rightPadCount; //indexing from bottom to top

        pad = motif.clone();
        pad.padstack().topCopper().width(padWidth);
        pad.padstack().topCopper().height(padHeight);
        pad.padstack().topCopper().rx(normalRx);
        pad.padstack().topCopper().ry(normalRy);

        pad.move(new lib_geometry.Coord(0.5 * hPitch, ((rightPadCount - 1) / 2 - rowIdx) * vPitch));

        pads.push(pad);
    }

    self.updatePads(pads, absolutePositions);
    return pads;
};
